import React, { useState } from 'react';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateUserStatus } from 'redux/reducers/userStatus';
import axios from 'axios';
import './styles.less';

const Forbidden = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const checkAuthorization = async () => {
    try {
      await axios.get('/api/authorization');
      return true;
    } catch (e) {
      return false;
    }
  };
  const handleButtonClick = async () => {
    setLoading(true);

    if (await checkAuthorization()) {
      dispatch(
        updateUserStatus({
          isAuthorized: true,
        }),
      );
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <div className="forbidden-page__container">
      <div className="forbidden-page__element">
        <span className="forbidden-page__number">403</span>
        <p className="forbidden-page__title">{t('forbidden.title')}</p>
        <p className="forbidden-page__content">{t('forbidden.content')}</p>
        <ul className="forbidden-page__roles-list">
          <li>Domain Admins</li>
          <li>UserLock SSO Admins</li>
        </ul>
        <p className="forbidden-page__content">
          {t('forbidden.restrictedAccess')}
          <br />
          {t('forbidden.contactAdmin')}
        </p>
        <Button
          className="forbidden-page__button"
          type="primary"
          onClick={handleButtonClick}
          loading={loading}
          disabled={loading}
        >
          {t('forms.retry')}
        </Button>
      </div>
    </div>
  );
};

export default Forbidden;
